module.exports = __webpack_public_path__ + "static/media/attachment-icon.c327c391.svg";